import type { RouteObject } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { StoreSubscriptionsPage } from "./pages/StoreSubscriptionsPage";
import { SubscriptionsPage } from "./pages/SubscriptionsPage";
import { useLocale } from "@admin/app/locale";

function toNumber(value: string | null, fallback: number) {
  const parsed = value ? Number(value) : Number.NaN;
  return Number.isFinite(parsed) ? parsed : fallback;
}

function AdminStoreSubscriptionsRoute() {
  const locale = useLocale();
  const [searchParams] = useSearchParams();

  return (
    <StoreSubscriptionsPage
      locale={locale}
      limit={toNumber(searchParams.get("limit"), 20)}
      offset={toNumber(searchParams.get("offset"), 0)}
      overdue={searchParams.get("overdue") === "true"}
      selectedPlanId={searchParams.get("planId")?.trim() || ""}
    />
  );
}

function AdminSubscriptionsRoute() {
  const locale = useLocale();
  const [searchParams] = useSearchParams();

  return (
    <SubscriptionsPage
      locale={locale}
      searchParams={{
        active: searchParams.get("active") ?? undefined,
        inactive: searchParams.get("inactive") ?? undefined,
        paid: searchParams.get("paid") ?? undefined,
        free: searchParams.get("free") ?? undefined,
      }}
    />
  );
}

export const subscriptionRoutes: RouteObject[] = [
  {
    path: "stores/subscriptions",
    element: <AdminStoreSubscriptionsRoute />,
  },
  {
    path: "subscriptions",
    element: <AdminSubscriptionsRoute />,
  },
];
